import { render, staticRenderFns } from "./WaterSetting.vue?vue&type=template&id=2c1461b0&scoped=true"
import script from "./WaterSetting.vue?vue&type=script&lang=js"
export * from "./WaterSetting.vue?vue&type=script&lang=js"
import style0 from "./WaterSetting.vue?vue&type=style&index=0&id=2c1461b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1461b0",
  null
  
)

export default component.exports